// (c) TwistedMinds, Gerry Uytdenhouwen - 3 november 2026

// Columns of the Excel export of the orders page: header -> order field.
export const ORDER_EXCEL_FIELDS = {
    "Name": "name",
    "Date": "date",
    "Address": "delivery.address",
    "Zip": "delivery.zip",
    "Vat number": "delivery.vat_number",
    "Info": "delivery.info",
    "Phone": "phone",
    "Email": "email",
    "Details": "details",
    "Payment method": "payment_method",
    "Time": "time",
    "Status": "status",
    "Amount": "amount",
    "Token": "token",
    "Delivery type": "delivery_type",
    "Created": "created_at",
    "Delivery cost": "delivery_cost",
};
